import swal from 'sweetalert';
import $ from 'jquery';
import I18n from 'i18n-js';
import select2 from 'select2';
import 'javascripts/i18n/translations';
import {toastr} from './notifications';

I18n.locale = window.I18n.locale;

document.addEventListener("turbolinks:before-cache", function () {
    $('[data-toggle="m-tooltip"]').tooltip('hide');
    $('.selectpicker').selectpicker('destroy');
});



$(document).on('turbolinks:load', function () {
    $(document).ready(function () {
        $("#hide_show_video").click(function () {
            $("#video-tuto").toggle();
        });
    });


    function file_pdf() {

        var fileInput = document.getElementById("pdfFile");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });

                document.getElementById("pdfFile").value = null;
            }
        } catch (e) {
            document.getElementById("pdfFile").value = null;
        }
    }

    //funcion para cargar el documento de opinion de cumplimiento
    $(document).off('click', '#cargarOpinionCumplimiento'); // elimina bindings previos
    $(document).on('click', '#cargarOpinionCumplimiento', function (event) {
        event.preventDefault();
        // alert("entro a cargar opinion cumplimiento");

        swal({
            title: 'Espere un momento',
            text: 'Cargando la opinión de cumplimiento',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttons: false,
            onOpen: function () {
                swal.showLoading()
            }
        });
        //
        // const xmlFile = document.getElementById("xmlFile").files[0];
        const pdfFile = document.getElementById("pdfFile").files[0];
        var basePdfFile;
        //
        if (!pdfFile  || pdfFile.type !== 'application/pdf') {
            swal({
                title: 'Es necesario adjuntar el PDF de la opinión de cumplimiento',
                icon: 'error',
                button: 'OK'
            });
            return;
        }
        //
        // // Leer primero el PDF
        const readerPdf = new FileReader();
        readerPdf.readAsDataURL(pdfFile);

        //

        // const ejercicio = document.getElementById("ejercicio").value;
        // const mes = document.getElementById("mes").value;

        const modal = $('#opinion_'); // capturamos el modal
        const ejercicio = modal.find('#anio').val();
        const mes = modal.find('#mes').val();

        // alert(ejercicio);
        // alert(mes);

        readerPdf.onload = function (e) {
            const basePdfFile = e.target.result;
            $.ajax({
                url: '/carga_opinioncumplimiento',
                data: {
                    pdfFile: basePdfFile,
                    anio: ejercicio,
                    mes: mes
                },
                type: 'POST',
                dataType: 'json',
                headers: { //este es el tocken para que funcione la llamada
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    document.getElementById("pdfFile").value = "";

                    const icon = data.success ? 'success' : 'error';

                    swal({
                        title: data.message,
                        icon: icon,
                        button: 'OK'
                    }).then(function () {
                        if (icon === 'success') location.reload();
                        // if (icon === 'success')
                        // window.location.href = window.location.href;


                    });

                },
                error: function () {
                    swal({
                        title: 'No se pudo cargar la opinión de cumplimiento',
                        icon: 'error',
                        button: 'OK'
                    });
                }
            });

        };
    });

    $(document).on('click', '#recargarOpinionCumplimiento', function (event) {
        event.preventDefault();
        // alert("entro a recargar opinion cumplimiento");

        const modal = event.target.closest('.modal');
        const idopinion = modal.dataset.idopinion;
        // alert(idopinion);

        swal({
            title: 'Espere un momento',
            text: 'Cargando nuevamente la opinión de cumplimiento',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttons: false,
            onOpen: function () {
                swal.showLoading()
            }
        });
        //
        // const xmlFile = document.getElementById("xmlFile").files[0];
        // const pdfFile = document.getElementById("pdfFile").files[0];
        const pdfFile = modal.querySelector('input[type="file"]').files[0];

        var basePdfFile;
        //
        if (!pdfFile  || pdfFile.type !== 'application/pdf') {
            swal({
                title: 'Es necesario adjuntar el PDF de la opinión de cumplimiento',
                icon: 'error',
                button: 'OK'
            });
            return;
        }
        //
        // // Leer primero el PDF
        const readerPdf = new FileReader();
        readerPdf.readAsDataURL(pdfFile);
        //
        readerPdf.onload = function (e) {
            const basePdfFile = e.target.result;
            $.ajax({
                url: '/recarga_opinioncumplimiento',
                data: {
                    pdfFile: basePdfFile,
                    idopinion: idopinion
                },
                type: 'POST',
                dataType: 'json',
                headers: { //este es el tocken para que funcione la llamada
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    document.getElementById("pdfFile").value = "";

                    const icon = data.success ? 'success' : 'error';

                    swal({
                        title: data.message,
                        icon: icon,
                        button: 'OK'
                    }).then(function () {
                        // if (icon === 'success')
                        window.location.href = "/listado_opinioncumplimiento";
                            // location.reload();
                        // if (icon === 'success')
                        // window.location.href = window.location.href;


                    });

                },
                error: function () {

                    alert("entro error");
                    let mensaje = "Error inesperado";

                    // if (xhr.responseJSON && xhr.responseJSON.message) {
                    //     mensaje = xhr.responseJSON.message;
                    //     // location.reload();
                    //     window.location.href = "/listado_opinioncumplimiento";
                    // }

                    swal({
                        title: mensaje,
                        icon: "error",
                        button: "OK"
                    });

                    // swal({
                    //     title: 'No se pudo cargar nuevamente la opinión de cumplimiento',
                    //     icon: 'error',
                    //     button: 'OK'
                    // });
                }
            });

        };
    });

    $(document).on('click', '.js-delete-opinioncumplimiento', function (event) {

        event.preventDefault();

        var url = $(this).data('url');

        swal({
            title: "¿Está seguro de continuar con la eliminación de la opinión de cumplimiento?",
            icon: "warning",
            buttons: ["Cancelar", "Continuar"],
            dangerMode: true
        }).then(function (willDelete) {

            if (willDelete) {
                $.ajax({
                    url: url,
                    type: "DELETE",
                    dataType: "json",
                    headers: {
                        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
                    },
                    success: function (data) {

                        const icon = data.success ? 'success' : 'error';

                        swal({
                            title: data.message,
                            icon: icon,
                            button: 'OK'
                        }).then(function () {
                                // alert("entro");
                            if (data.success) {
                                window.location.href = "/listado_opinioncumplimiento";
                            }
                        });
                    },
                    error: function (xhr) {

                        let mensaje = "Error inesperado";

                        if (xhr.responseJSON && xhr.responseJSON.message) {
                            mensaje = xhr.responseJSON.message;
                            window.location.href = "/listado_opinioncumplimiento";
                        }

                        swal({
                            title: mensaje,
                            icon: "error",
                            button: "OK"
                        });
                    }
                });
            }
        });
        // event.preventDefault();
        // // event.stopImmediatePropagation();
        //
        // // console.log("entro al clic de eliminar opinioncumplimiento ")
        //
        // alert("entro a eliminar opinion cumplimiento");
        //
        // var url = $(this).data('url');
        //
        // swal({
        //     title: "¿Está seguro de continuar con la eliminación de la opinión de cumplimiento?",
        //     // text: "Al eliminar la validación de la factura, también se eliminarán los complementos relacionados.",
        //     icon: "warning",
        //     buttons: ["Cancelar", "Continuar"],
        //     dangerMode: true
        // }).then(function (willDelete) {
        //     if (willDelete) {
        //         fetch(url, {
        //             method: "DELETE",
        //             headers: {
        //                 "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        //             }
        //         }).then(function () {
        //             swal(
        //                 "Eliminado",
        //                 "La opinión de cumplimiento fue eliminada con éxito.",
        //                 "success"
        //             ).then(function () {
        //                 // location.reload();
        //                 window.location.href = "/listado_opinioncumplimiento";
        //
        //                 // window.location.href = window.location.pathname;
        //                 // Turbo.visit(window.location.href, { action: "replace" });
        //
        //             });
        //         });
        //     }
        // });
    });

    // $('#validateID').on('click', function () {
    //     swal({
    //         title: 'Espere un momento',
    //         text: 'Validando la factura',
    //         allowOutsideClick: false,
    //         allowEscapeKey: false,
    //         allowEnterKey: false,
    //         buttons: false,
    //         onOpen: function () {
    //             swal.showLoading()
    //         }
    //     });
    //     var xmlFile = document.getElementById("xmlFile").files[0];
    //
    //     var pdfFile = document.getElementById("pdfFile").files[0];
    //     var basePdfFile;
    //     if (xmlFile === undefined  || pdfFile === undefined || xmlFile['type'] !== 'text/xml' ||
    //         pdfFile['type'] !== 'application/pdf'){
    //         swal({
    //             title: 'Es necesario adjuntar un archivo xml y un archivo pdf',
    //             text: '',
    //             icon: 'error',
    //             button: 'OK'
    //         }).then(function () {
    //             // location.reload()
    //         });
    //
    //     }else{
    //         var readerPdf = new FileReader();
    //         readerPdf.readAsDataURL(pdfFile);
    //
    //         readerPdf.onload = function(e) {
    //
    //             basePdfFile = e.target.result;
    //         };
    //
    //         var reader = new FileReader();
    //         reader.readAsText(xmlFile);
    //         reader.onload = function(e) {
    //
    //             var readXml = e.target.result;
    //             $.ajax({
    //                 url: '/validate_xml',
    //                 data: {
    //                     xmlFile: readXml,
    //                     pdfFile: basePdfFile
    //                 },
    //                 type: 'POST',
    //                 dataType: 'json',
    //                 success: function (data) {
    //                     if (data.message === '0 - Sin Errores.'){
    //
    //                         document.getElementById("xmlFile").value = "";
    //                         document.getElementById("pdfFile").value = "";
    //
    //                         swal({
    //                             title: data.message,
    //                             text: '',
    //                             icon: 'success',
    //                             button: 'OK'
    //                         }).then(function () {
    //                             location.reload()
    //                         });
    //                     }else{
    //                         document.getElementById("xmlFile").value = "";
    //                         document.getElementById("pdfFile").value = "";
    //                         swal({
    //                             title: data.message,
    //                             text: '',
    //                             icon: 'error',
    //                             button: 'OK'
    //                         }).then(function () {
    //                             // location.reload()
    //                         });
    //                     }
    //                 },
    //                 error: function (error) {
    //                     swal({
    //                         title:
    //                         'Sin comunicación con el servidor PAC.',
    //                         text: '',
    //                         icon: 'error',
    //                         button: 'OK'
    //                     }).then(function () {
    //                         // location.reload()
    //                     });
    //                 }
    //             });
    //         }
    //     }
    //
    //
    // });
    //copiaaaaaaa
    $(document).off('click', '#validateID'); // elimina bindings previos
    $(document).on('click', '#validateID', function (event) {
        // alert("entro al java");
        event.preventDefault();

        const button = $(this);
        if (button.data('processing')) return; // si ya está procesando, salir
        button.data('processing', true);

        swal({
                title: 'Espere un momento',
                text: 'Validando la factura',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                buttons: false,
                onOpen: function () {
                    swal.showLoading()
                }
            });

        const xmlFile = document.getElementById("xmlFile").files[0];
        const pdfFile = document.getElementById("pdfFile").files[0];
        var basePdfFile;

        if (!xmlFile || !pdfFile || xmlFile.type !== 'text/xml' || pdfFile.type !== 'application/pdf') {
            swal({
                title: 'Es necesario adjuntar un archivo XML y un archivo PDF',
                icon: 'error',
                button: 'OK'
            });
            button.data('processing', false); // reactivar botón
            return;
        }

        // Leer primero el PDF
        const readerPdf = new FileReader();
        readerPdf.readAsDataURL(pdfFile);

        readerPdf.onload = function (e) {
            const basePdfFile = e.target.result;

            // Ahora leer el XML solo cuando el PDF ya esté listo
            const readerXml = new FileReader();
            readerXml.readAsText(xmlFile);

            readerXml.onload = function (e) {
                const readXml = e.target.result;
                // console.log("idOrdenIndetec=" + idOrdenIndetec)
                $.ajax({
                    url: '/validate_xml',
                    data: {
                        xmlFile: readXml,
                        pdfFile: basePdfFile
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        button.data('processing', false);

                        document.getElementById("xmlFile").value = "";
                        document.getElementById("pdfFile").value = "";

                        const icon = data.message === '0 - Sin Errores.' ? 'success' : 'error';

                        swal({
                            title: data.message,
                            icon: icon,
                            button: 'OK'
                        }).then(function () {
                            if (icon === 'success') location.reload();
                            // if (icon === 'success')
                            // window.location.href = window.location.href;


                        });
                    },
                    error: function () {
                        button.data('processing', false);

                        swal({
                            title: 'Sin comunicación con el servidor PAC.',
                            icon: 'error',
                            button: 'OK'
                        });
                    }

                });
            };
        };
    });

    //copiaaaa
    var basePdfFileComplemento
    window.validateComplement = function(facturaId){

        // var facturaIdLocal = facturaId;

        swal({
            title: 'Espere un momento',
            text: 'Validando el complemento',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttons: false,
            onOpen: function () {
                swal.showLoading()
            }
        });
        var xmlFile = document.getElementById("xmlFile"+facturaId).files[0];
        var pdfFileComplemento = document.getElementById("pdfFile"+facturaId).files[0];
        //var basePdfFileComplemento = null;
        var baseXMLFileComplemento = null;

        if (xmlFile === undefined  || pdfFileComplemento === undefined || xmlFile['type'] !== 'text/xml' ||
            pdfFileComplemento['type'] !== 'application/pdf'){
            swal({
                title: 'Es necesario adjuntar un archivo xml y un archivo pdf',
                text: '',
                icon: 'error',
                button: 'OK'
            }).then(function () {
                // location.reload()
            });

        }else{


            var reader = new FileReader();
            reader.readAsText(xmlFile);

            // reader.onload = function(e) {
            //     baseXMLFileComplemento = e.target.result;
            // }

            var readerPdfComplemento = new FileReader();
            readerPdfComplemento.readAsDataURL(pdfFileComplemento);

            var xmlLeido = false;
            var pdfLeido = false;

            reader.onload = function(e) {
                baseXMLFileComplemento = e.target.result;
                xmlLeido = true;
                // if (pdfLeido) enviarComplemento(); // 🔁 se llama solo si ambos archivos están listos
                if (xmlLeido && pdfLeido) {
                    console.log("1");
                    enviarComplemento(3, facturaId,baseXMLFileComplemento,basePdfFileComplemento);
                }
            };

            readerPdfComplemento.onload = function(e) {
                basePdfFileComplemento = e.target.result;
                pdfLeido = true;
                // if (xmlLeido) enviarComplemento(); // 🔁 se llama solo si ambos archivos están listos
                if (xmlLeido && pdfLeido) {
                    console.log("2");
                    enviarComplemento(3,facturaId,baseXMLFileComplemento,basePdfFileComplemento);
                }
            };


            // readerPdfComplemento.onload = function(e) {
            //       basePdfFileComplemento = e.target.result;








                // enviarComplemento(); // 🔁 con reintentos automáticos

                // var basePdfFileComplemento = e.target.result;
                // $.ajax({
                //     url: '/leer_complemento',
                //     data: {
                //         xmlFile: baseXMLFileComplemento,
                //         pdfFile: basePdfFileComplemento,
                //         facturaId : facturaId
                //     },
                //     type: 'POST',
                //     dataType: 'json',
                //     success: function (data) {
                //
                //         console.log('Respuesta del servidor:', data);
                //         // Limpiar inputs
                //         document.getElementById("xmlFile" + facturaId).value = "";
                //         document.getElementById("pdfFile" + facturaId).value = "";
                //
                //
                //         if (data.message === '0 - Sin Errores.'){
                //             document.getElementById("xmlFile"+facturaId).value = "";
                //             document.getElementById("pdfFile"+facturaId).value = "";
                //             swal({
                //                 title: data.message,
                //                 text: '',
                //                 icon: 'success',
                //                 button: 'OK'
                //             }).then(function () {
                //                 location.reload()
                //             });
                //         }else{
                //
                //             console.log("entro al primer else");
                //             console.log('mensaje=', data.message);
                //             document.getElementById("xmlFile"+facturaId).value = "";
                //             document.getElementById("pdfFile"+facturaId).value = "";
                //
                //             if (data.status === 'varias')
                //             {
                //                 console.log("entro al varias");
                //                 swal({
                //                     title: data.message,
                //                     text: '',
                //                     icon: "info",
                //                     buttons: ["Cancelar", "Aceptar"],
                //                 }).then(function (aceptar) {
                //                     if (aceptar) {
                //                         // Usuario hizo clic en "Aceptar"
                //                         $.ajax({
                //                             url: '/aplicarcomplemento_variasfacturas', // tu ruta Rails
                //                             type: 'POST',
                //                             dataType: 'json',
                //                             data: {
                //                                 xmlFile: baseXMLFileComplemento,
                //                                 pdfFile: basePdfFileComplemento,
                //                                 facturaId : facturaId
                //                             }, // si necesitas mandar datos
                //                             success: function(resp) {
                //                                 // swal({
                //                                 //     title: resp.message,
                //                                 //     icon: 'success',
                //                                 //     button: 'OK'
                //                                 // }).then(function() {
                //                                 //     location.reload();
                //                                 // });
                //                                 let detalles = "";
                //                                 if (resp.resultados && Array.isArray(resp.resultados) && resp.resultados.length > 0) {
                //                                     detalles = resp.resultados.map(function(r) {
                //                                         let icono = r.status === 'ok' ? '✅' : '❌';
                //                                         return `${icono} ${r.documento}: ${r.message}`;
                //                                     }).join('\n');
                //                                 }
                //                                 let iconoSwal = 'success';
                //                                 if (resp.resultados && resp.resultados.some(r => r.status !== 'ok')) {
                //                                     iconoSwal = 'warning';
                //                                 }
                //                                 // Mostrar el swal con resultados o mensaje único
                //                                 swal({
                //                                     title: resp.message || 'Resultado del proceso',
                //                                     text: detalles || '',
                //                                     icon: iconoSwal,
                //                                     button: 'OK'
                //                                 }).then(function() {
                //                                     location.reload();
                //                                 });
                //
                //                             },
                //                             error: function(xhr, status, error) {
                //                                 swal({
                //                                     title: 'Error',
                //                                     text: 'Ocurrió un problema al aplicar el complemento.',
                //                                     icon: 'error',
                //                                     button: 'OK'
                //                                 });
                //                                 console.error('Error AJAX:', error);
                //                             }
                //                         });
                //                     } else {
                //                         //lo comente para que no se repitiera el caso d que se queden facturas sin complemento
                //                         // hacer la funcion normal de validacion
                //                         // $.ajax({
                //                         //     url: '/validate_complement', // tu ruta Rails
                //                         //     type: 'POST',
                //                         //     dataType: 'json',
                //                         //     data: {
                //                         //         xmlFile: baseXMLFileComplemento,
                //                         //         pdfFile: basePdfFileComplemento,
                //                         //         facturaId : facturaId
                //                         //     }, // si necesitas mandar datos
                //                         //     success: function(resp) {
                //                         //         if (resp.status === 'error'){
                //                         //             swal({
                //                         //                 title: resp.message,
                //                         //                 icon: 'error',
                //                         //                 button: 'OK'
                //                         //             }).then(function() {
                //                         //                 location.reload();
                //                         //             });
                //                         //         }else {
                //                         //             swal({
                //                         //                 title: resp.message,
                //                         //                 icon: 'success',
                //                         //                 button: 'OK'
                //                         //             }).then(function() {
                //                         //                 location.reload();
                //                         //             });
                //                         //         }
                //                         //
                //                         //     },
                //                         //     error: function(xhr, status, error) {
                //                         //         swal({
                //                         //             title: 'Error',
                //                         //             text: 'Ocurrió un problema al aplicar el complemento.',
                //                         //             icon: 'error',
                //                         //             button: 'OK'
                //                         //         });
                //                         //         console.error('Error AJAX:', error);
                //                         //     }
                //                         // });
                //                     }
                //
                //                     // location.reload()
                //                 });
                //
                //             }else
                //             {
                //                 console.log("entro al segundo else");
                //                 console.log(data.status);
                //                 if (data.status === 'una')
                //                 {
                //                     console.log("entro a una");
                //
                //                     //hacer la funcion normal de validacion
                //                     $.ajax({
                //                         url: '/validate_complement', // tu ruta Rails
                //                         type: 'POST',
                //                         dataType: 'json',
                //                         data: {
                //                             xmlFile: baseXMLFileComplemento,
                //                             pdfFile: basePdfFileComplemento,
                //                             facturaId : facturaId
                //                         }, // si necesitas mandar datos
                //                         success: function(resp) {
                //                             if (resp.status === 'error'){
                //                                 swal({
                //                                     title: resp.message,
                //                                     icon: 'error',
                //                                     button: 'OK'
                //                                 }).then(function() {
                //                                     location.reload();
                //                                 });
                //                             }else {
                //                                 swal({
                //                                     title: resp.message,
                //                                     icon: 'success',
                //                                     button: 'OK'
                //                                 }).then(function() {
                //                                     location.reload();
                //                                 });
                //                             }
                //
                //                         },
                //                         error: function(xhr, status, error) {
                //                             swal({
                //                                 title: 'Error',
                //                                 text: 'Ocurrió un problema al aplicar el complemento.',
                //                                 icon: 'error',
                //                                 button: 'OK'
                //                             });
                //                             console.error('Error AJAX:', error);
                //                         }
                //                     });
                //                 }
                //                 else {
                //                     console.log("entro al otro else");
                //                     swal({
                //                         title: data.message,
                //                         text: '',
                //                         icon: 'error',
                //                         button: 'OK'
                //                     }).then(function () {
                //
                //                         // location.reload()
                //                     });
                //                 }
                //
                //             }
                //
                //         }
                //     },
                //     error: function (error) {
                //         var basePdfFileComplemento = null;
                //         swal({
                //             title:
                //                 ' Error al procesar el complemento, intente de nuevo.',
                //             text: '',
                //             icon: 'error',
                //             button: 'OK'
                //         }).then(function () {
                //             // location.reload()
                //         });
                //     }
                // });
            // }
        }
    }


    function enviarComplemento(reintentos,facturaId,baseXMLFileComplemento,basePdfFileComplemento) {
        let formData = new FormData();

        formData.append('xmlFile', document.getElementById("xmlFile" + facturaId).files[0]);
        formData.append('pdfFile', document.getElementById("pdfFile" + facturaId).files[0]);
        formData.append('facturaId', facturaId);

        $.ajax({
            url: '/leer_complemento',
            type: 'POST',
            data: formData,
            processData: false, // 🔴 OBLIGATORIO
            contentType: false, // 🔴 OBLIGATORIO
            timeout: 60000,
            success: function(data) {
                // alert('todo bien al leer_complemento, se manda el procesarRespuesta');
                console.log("success de leer_complemento");
                procesarRespuesta(data,facturaId,baseXMLFileComplemento,basePdfFileComplemento);
            },
            error: function(xhr, status) {
                if (reintentos > 0) {
                    setTimeout(() => enviarComplemento(reintentos - 1), 1500);
                } else {
                    swal({
                        title: 'Error',
                        text: 'No se pudo procesar el complemento.',
                        icon: 'error'
                    });
                }
            }
        });

    }
    function procesarRespuesta(data,facturaId,baseXMLFileComplemento,basePdfFileComplemento) {

        console.log('Respuesta del servidor:', data);

        // Limpiar inputs
        document.getElementById("xmlFile" + facturaId).value = "";
        document.getElementById("pdfFile" + facturaId).value = "";

        if (data.message === '0 - Sin Errores.') {

            swal({
                title: data.message,
                icon: 'success',
                button: 'OK'
            }).then(function () {
                location.reload();
            });

        } else {

            console.log("entro al primer else");
            console.log('mensaje=', data.message);

            if (data.status === 'varias') {

                swal({
                    title: data.message,
                    icon: "info",
                    buttons: ["Cancelar", "Aceptar"],
                }).then(function (aceptar) {

                    if (aceptar) {

                        $.ajax({
                            url: '/aplicarcomplemento_variasfacturas',
                            type: 'POST',
                            dataType: 'json',
                            timeout: 30000,
                            data: {
                                xmlFile: baseXMLFileComplemento,
                                pdfFile: basePdfFileComplemento,
                                facturaId: facturaId
                            },
                            success: function(resp) {

                                let detalles = "";

                                if (resp.resultados && Array.isArray(resp.resultados)) {
                                    detalles = resp.resultados.map(function(r) {
                                        let icono = r.status === 'ok' ? '✅' : '❌';
                                        return `${icono} ${r.documento}: ${r.message}`;
                                    }).join('\n');
                                }

                                // let iconoSwal = 'success';
                                // // alert(resp)         ;
                                // if (resp.resultados && resp.resultados.some(r => r.status !== 'ok')) {
                                //     iconoSwal = 'warning';
                                // }
                                let iconoSwal = (resp.status === 'error') ? 'error' : 'success';

                                swal({
                                    title: resp.message || 'Resultado del proceso',
                                    text: detalles,
                                    icon: iconoSwal,
                                    button: 'OK'
                                }).then(function() {
                                    location.reload();
                                });

                            },
                            error: function() {
                                swal({
                                    title: 'Error',
                                    text: 'Ocurrió un problema al aplicar el complemento.',
                                    icon: 'error',
                                    button: 'OK'
                                });
                            }
                        });

                    }

                });

            } else if (data.status === 'una') {

                $.ajax({
                    url: '/validate_complement',
                    type: 'POST',
                    dataType: 'json',
                    timeout: 30000,
                    data: {
                        xmlFile: baseXMLFileComplemento,
                        pdfFile: basePdfFileComplemento,
                        facturaId: facturaId
                    },
                    success: function(resp) {

                        swal({
                            title: resp.message,
                            icon: resp.status === 'error' ? 'error' : 'success',
                            button: 'OK'
                        }).then(function() {
                            location.reload();
                        });

                    },
                    error: function() {
                        swal({
                            title: 'Error',
                            text: 'Ocurrió un problema al aplicar el complemento.',
                            icon: 'error',
                            button: 'OK'
                        });
                    }
                });

            } else {

                swal({
                    title: data.message,
                    icon: 'error',
                    button: 'OK'
                });

            }
        }
    }



    //buenoooooooooooo
    // window.validateComplement = function(facturaId){
    //buenoooooo
    //     // var facturaIdLocal = facturaId;
    //
    //     swal({
    //         title: 'Espere un momento',
    //         text: 'Validando el complemento',
    //         allowOutsideClick: false,
    //         allowEscapeKey: false,
    //         allowEnterKey: false,
    //         buttons: false,
    //         onOpen: function () {
    //             swal.showLoading()
    //         }
    //     });
    //     var xmlFile = document.getElementById("xmlFile"+facturaIdLocal).files[0];
    //     var pdfFileComplemento = document.getElementById("pdfFile"+facturaIdLocal).files[0];
    //     //var basePdfFileComplemento = null;
    //     var baseXMLFileComplemento = null;
    //
    //     if (xmlFile === undefined  || pdfFileComplemento === undefined || xmlFile['type'] !== 'text/xml' ||
    //         pdfFileComplemento['type'] !== 'application/pdf'){
    //         swal({
    //             title: 'Es necesario adjuntar un archivo xml y un archivo pdf',
    //             text: '',
    //             icon: 'error',
    //             button: 'OK'
    //         }).then(function () {
    //             // location.reload()
    //         });
    //
    //     }else{
    //
    //
    //         var reader = new FileReader();
    //         reader.readAsText(xmlFile);
    //         reader.onload = function(e) {
    //             baseXMLFileComplemento = e.target.result;
    //         }
    //
    //         var readerPdfComplemento = new FileReader();
    //         readerPdfComplemento.readAsDataURL(pdfFileComplemento);
    //         readerPdfComplemento.onload = function(e) {
    //             var basePdfFileComplemento = e.target.result;
    //             $.ajax({
    //                 url: '/validate_complement',
    //                 data: {
    //                     xmlFile: baseXMLFileComplemento,
    //                     pdfFile: basePdfFileComplemento
    //                 },
    //                 type: 'POST',
    //                 dataType: 'json',
    //                 success: function (data) {
    //
    //                     console.log("entro");
    //                     // Limpiar inputs
    //                     document.getElementById("xmlFile" + facturaIdLocal).value = "";
    //                     document.getElementById("pdfFile" + facturaIdLocal).value = "";
    //
    //                     // // Caso de varias facturas
    //                     // if (data.alert) {
    //                     //     Swal.fire({
    //                     //         title: "Atención",
    //                     //         text: data.alert,
    //                     //         icon: "warning",
    //                     //         showCancelButton: true,
    //                     //         confirmButtonText: "Aplicar a todas",
    //                     //         cancelButtonText: "Cancelar"
    //                     //     }).then((result) => {
    //                     //         if (result.isConfirmed) {
    //                     //             // acción al aceptar
    //                     //         } else {
    //                     //             Swal.fire("El complemento no se aplicó.", "", "info");
    //                     //         }
    //                     //     });
    //                     //
    //                     //
    //                     // }
    //
    //
    //
    //                     if (data.message === '0 - Sin Errores.'){
    //                         document.getElementById("xmlFile"+facturaIdLocal).value = "";
    //                         document.getElementById("pdfFile"+facturaIdLocal).value = "";
    //                         swal({
    //                             title: data.message,
    //                             text: '',
    //                             icon: 'success',
    //                             button: 'OK'
    //                         }).then(function () {
    //                             location.reload()
    //                         });
    //                     }else{
    //                         document.getElementById("xmlFile"+facturaIdLocal).value = "";
    //                         document.getElementById("pdfFile"+facturaIdLocal).value = "";
    //                         swal({
    //                             title: data.message,
    //                             text: '',
    //                             icon: 'error',
    //                             button: 'OK'
    //                         }).then(function () {
    //
    //                             // location.reload()
    //                         });
    //                     }
    //                 },
    //                 error: function (error) {
    //                     var basePdfFileComplemento = null;
    //                     swal({
    //                         title:
    //                             'Sin comunicación con el servidor PAC.(JS)',
    //                         text: '',
    //                         icon: 'error',
    //                         button: 'OK'
    //                     }).then(function () {
    //                         // location.reload()
    //                     });
    //                 }
    //             });
    //         }
    //     }
    // }


    window.guardaDetalleRequi = function(iddRequi, idRequiProvvedor,cantidad){

        var valor = document.getElementById('valor_u'+iddRequi).value ;
        var subtotal = document.getElementById('subtotal'+iddRequi);
        subtotal.value = valor * cantidad ;
        var subtotal_val = document.getElementById('subtotal'+iddRequi).value;
        if (valor  > 0 ){
        $.ajax({
            url: '/guarda_detalle_requi',
            data: {
                iddRequi: iddRequi,
                idRequiProvvedor: idRequiProvvedor,
                valor: valor,
                subtotal_val: subtotal_val
            },
            type: 'POST',
            dataType: 'json',
            success: function (data) {},
            error: function (error) {
                var basePdfFileComplemento = null;
                swal({
                    title:
                        'Ah ocurrido un error. Favor de Capturar importe de nuevo',
                    text: '',
                    icon: 'error',
                    button: 'OK'
                }).then(function () {
                    // location.reload()
                });
            }
        });
    }
    }

    window.guardaCotizacion = function(requiId){
        swal({
            title: 'Espere un momento',
            text: 'Registrando Cotización',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttons: false,
            onOpen: function () {
                swal.showLoading()
            }
        });
        var pdfFileComplemento = document.getElementById("pdfFile"+requiId).files[0];
        var moneda = document.getElementById("moneda").value;
        var vigencia = document.getElementById("vigencia").value;
        var garantia = document.getElementById("garantia").value;
        var unidadgarantia = document.getElementById("unidadGarantia").value;
        var entrega = document.getElementById("entrega").value;
        var unidadentrega = document.getElementById("unidadEntrega").value;
        var iva = document.getElementById("iva").value;
        var notas = document.getElementById("notas").value;

        if (pdfFileComplemento === undefined  ||
            pdfFileComplemento['type'] !== 'application/pdf'){
            swal({
                title: 'Es necesario adjuntar un archivo pdf de Cotización' ,
                text: '',
                icon: 'error',
                button: 'OK'
            }).then(function () {
                // location.reload()
            });

        }else{

            var readerPdfComplemento = new FileReader();
            readerPdfComplemento.readAsDataURL(pdfFileComplemento);
            readerPdfComplemento.onload = function(e) {
                var basePdfFileComplemento = e.target.result;
                $.ajax({
                    url: '/guarda_cotizacion',
                    data: {
                        pdfFile: basePdfFileComplemento,
                        requiId: requiId,
                        moneda: moneda,
                        vigencia: vigencia,
                        garantia: garantia,
                        unidadgarantia: unidadgarantia,
                        entrega: entrega,
                        unidadentrega: unidadentrega,
                        iva: iva,
                        notas: notas
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if (data.message === 'Cotización registrada con éxito'){
                            document.getElementById("pdfFile"+requiId).value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'success',
                                button: 'OK'
                            }).then(function () {
                                location.replace("/requisiciones");
                            });
                        }else{
                            document.getElementById("pdfFile"+requiId).value = "";
                            swal({
                                title: data.message,
                                text: '',
                                icon: 'error',
                                button: 'OK'
                            }).then(function () {

                                // location.reload()
                            });
                        }
                    },
                    error: function (error) {
                        var basePdfFileComplemento = null;
                        swal({
                            title:
                                'Ah Ocurrido un error al guardar Cotización',
                            text: '',
                            icon: 'error',
                            button: 'OK'
                        }).then(function () {
                            // location.reload()
                        });
                    }
                });
            }
        }
    }



});

let cascadeSelects = (source, destination, url) => {
    let ajaxRequest = (resource, edit) => {
        if (resource !== '') {
            $.get(url, {resource: resource}, function (data) {
                destination.empty();
                if (data.length > 0) {
                    for (let action of data) {
                        destination.append($('<option>', {value: action[0], text: action[1]}));
                    }
                    edit && destination.val(destination.data('value'));
                } else {
                    destination.append($('<option>', {value: '', text: I18n.t('helpers.select.no_options')}));
                }
                $('.selectpicker').selectpicker('refresh');
            })
                .fail(function () {
                    toastr.warning(I18n.t('messages.try_again'));
                });
        }
    };

    ajaxRequest(source.val(), true);

    source.on('change', function (e) {
        let resource = $(e.target).val();
        ajaxRequest(resource, false);
    });
};

//SOLO NUMEROS
$(function(){
    $(".numerico").keydown(function(event){
        //alert(event.keyCode);
        if((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105) && event.keyCode !==190  && event.keyCode !==110 && event.keyCode !==8 && event.keyCode !==9  ){
            return false;
        }
    });
});



export {cascadeSelects};


